<template>
    <v-app>
        <v-main>
            <v-container>
                <h1>MyBooking Encrid Decryption </h1>
                <v-row class="mt-5 mb-5">
                    <v-col cols="8">
                        <v-text-field v-model="encrid" dense label="Encrid"></v-text-field>
                    </v-col>
                    <v-col cols="1">
                        <v-btn dense small @click="decrypt()">decrypt</v-btn>
                    </v-col>
                    <v-col cols="3">
                        <v-checkbox v-model="forceAllKeys" dense small label="Force all keys"></v-checkbox>
                    </v-col>                                  
                </v-row>   
                <div v-if="show">
                    <div style="display: grid; grid-template-columns: repeat(12, 1fr);">
                        <div>Stage</div>
                        <div>Decryption key</div>
                        <div style="grid-column-start: 3; grid-column-end: span 3">Decrypted value</div>
                        <div style="margin-left: auto; margin-right: auto;">Rowid, Ent. 2</div>
                        <div style="margin-left: auto; margin-right: auto;">Rowid, Ent. 1</div>
                        <div style="margin-left: auto; margin-right: auto;">Code, Ent. 2</div>
                        <div style="margin-left: auto; margin-right: auto; padding-right: 4px;">Guestcode</div>
                    </div>
                    <hr class="my-2" style="width: 73%"/>
                    <div style="display: grid; grid-template-columns: repeat(12, 1fr);" v-for="(item, i) in data.decrypt" :key="i">
                        <div style="margin-bottom: 15px;">{{ item.stage }}</div>
                        <div>{{ item.key }}</div>
                        <div style="grid-column-start: 3; grid-column-end: span 3">{{ item.value }}</div>
                        <div v-if="item.kl_rowid_entry2"><v-icon  color="green" style="width:100%;">mdi-check-bold</v-icon></div>
                        <div v-else><v-icon color="red" style="width:100%;">mdi-close-thick</v-icon></div>
                        <div v-if="item.kl_rowid_entry1"><v-icon color="green" style="width:100%;">mdi-check-bold</v-icon></div>
                        <div v-else><v-icon color="red" style="width:100%;">mdi-close-thick</v-icon></div>
                        <div v-if="item.kl_code_entry2"><v-icon color="green" style="width:100%;">mdi-check-bold</v-icon></div>
                        <div v-else><v-icon color="red" style="width:100%;">mdi-close-thick</v-icon></div>                    
                        <div style="margin-left: auto; margin-right: auto;">{{ item.kl_code }}</div>
                    </div>
                </div>
            </v-container>
        </v-main>
        <navBar title="Ares - Reference data" :home="true" type="referencedata"/>        
    </v-app>
</template>
<script>
import navBar from "@/components/ui/navbars/navbar.vue";
export default {
    components: {
        navBar
    },
    data() { 
        return {
            data: [],
            encrid: '',
            show: false,
            forceAllKeys: false
        }
    },
    async mounted(){
    },    
    methods: {
        isEmpty(obj){
            return Object.keys(obj).length === 0
        },
        decrypt(){
            this.show=false
            this.$axios.post("ares/json/ares/syst/misc/decryptEncrid.p", {
            header: {
                token: this.$session.get("ARES"),
                clientSessionId: this.$session.id(),
                request: "decrypt"
            },
            decrypt: {
                encrid: this.encrid,
                force: this.forceAllKeys
            }
            })
            .then(res => {
                this.data = res.data
                if(res.data.decrypt.length!==0)this.show=true
                // localStorage.setItem("mybooking.huov", this.huovcode)
                // localStorage.setItem("mybooking.local-ip", this.ip)
            });            
        }
    }          
}
</script>    
<style scoped>

</style>